import React from 'react';
import { Calendar, X } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { DatePicker, dateToCalendarDate, calendarDateToDate } from '@/components/ui/date-picker';
import { Button } from '@/components/ui/button';

const DateFilter = ({
  dateFrom,
  dateTo,
  dateField,
  onDateFromChange,
  onDateToChange,
  onDateFieldChange,
  onClearFilter,
  inModal = false
}) => {
  const dateFieldOptions = [
    { value: 'fecini', label: 'Fecha de inicio' },
    { value: 'fecfirma', label: 'Fecha de firma' }
  ];

  return (
    <div className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-2">
        <Calendar className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por fechas</span>
      </div>

      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3">
        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Campo de fecha</label>
          <Select value={dateField} onValueChange={onDateFieldChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Seleccionar campo" />
            </SelectTrigger>
            <SelectContent>
              {dateFieldOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Fecha desde</label>
          <DatePicker
            value={dateToCalendarDate(dateFrom)}
            aria-label="Fecha desde"
            onChange={(calendarDate) => {
              const date = calendarDateToDate(calendarDate);
              onDateFromChange(date);
            }}
            placeholder="Seleccionar fecha"
            inModal={inModal}
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Fecha hasta</label>
          <DatePicker
            value={dateToCalendarDate(dateTo)}
            aria-label="Fecha hasta"
            onChange={(calendarDate) => {
              const date = calendarDateToDate(calendarDate);
              onDateToChange(date);
            }}
            placeholder="Seleccionar fecha"
            inModal={inModal}
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600 invisible">Acciones</label>
          <div className="flex gap-2">
            <Button
              onClick={onClearFilter}
              variant="outline"
              size="sm"
              className="px-3"
              disabled={!dateFrom && !dateTo}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
